'use strict';

/* eslint-disable max-lines-per-function, complexity */

angular.module('webAgro1App').factory('TarefaObjectService', function($filter, filterFilter, OperacoesDadosService) {
  return {
    convertToSend: function(tarefa, shouldRepeat, hasBulk) {
      const result = {
        acao: tarefa.observacao,
        cd_propriedade: tarefa.propriedade.id,
        data_final: $filter('date')(tarefa.dataFinal, DATE_FORMAT),
        data_inicial: $filter('date')(tarefa.dataInicial, DATE_FORMAT),
        id: tarefa.id || null,
        responsavel_id: tarefa.responsavel ? tarefa.responsavel.id : 0,
        encarregado_ids: (tarefa.encarregados || []).map((encarregado) => encarregado.id),
        parametro_attributes: {
          cd_safra: tarefa.safra.id,
          cd_insumo: (tarefa.cultivar || {}).item_id,
          tp_insumo: (tarefa.cultivar || {}).tipo_item,
          cd_atividade: tarefa.atividade_id
        },
        parametros: tarefa.parametros,
        tipo: tarefa.tipo.tipo,
        quantity: shouldRepeat && !hasBulk && tarefa.quantity,
        interval: shouldRepeat && !hasBulk && tarefa.interval,
        padrao_embrapa: tarefa.padrao_embrapa,
        pragas_attributes: (tarefa.pragas || []).map((praga) => ({ tipo_ocorrencia_id: praga.id }))
      };

      if (tarefa.tipo.tipo === 'geral' && !(tarefa.markers || []).length) {
        result.glebas_attributes = tarefa.glebas.map(function(gleba) {
          return {
            gleba_id: gleba.id
          };
        });
      }

      let pontos = (tarefa.markers || tarefa.leafletMarkers || []).map(function(data) {
        return {
          latitude: data.position ? data.position.lat() : data.getLatLng().lat,
          longitude: data.position ? data.position.lng() : data.getLatLng().lng,
          precisao: 'MANUAL',
          id: data.id || null,
          comentario: data.comentario
        };
      });

      if (tarefa.markersDeleted) {
        pontos = pontos.concat(tarefa.markersDeleted.map(function(data) {
          return {
            id: data.id,
            _destroy: '1'
          };
        }));
      }

      result.pontos_attributes = pontos;

      return result;
    },

    getTarefaTipo: function(tipo) {
      return filterFilter(TAREFA_TIPOS, { tipo: tipo }, true)[0] ||
             filterFilter(TAREFA_TIPOS, { id: tipo }, true)[0] ||
             {};
    },

    convertToObject: function(tarefa) {
      return (!tarefa || !tarefa.id) ? {} : {
        createdAt: tarefa.created_at,
        dataFinal: moment(tarefa.data_final).toDate(),
        dataInicial: moment(tarefa.data_inicial).toDate(),
        finalizadoEm: tarefa.finalizado_em,
        glebas: tarefa.glebas || [],
        id: tarefa.id,
        imagens: OperacoesDadosService.getImagesObject(tarefa.imagens, true),
        imagensOrigem: OperacoesDadosService.getImagesObject(tarefa.imagens_origem, true),
        markersDeleted: [],
        observacao: tarefa.acao,
        observacaoFinal: tarefa.observacoes,
        parametros: tarefa.parametros,
        pontos: tarefa.pontos,
        pontosRealizados: (tarefa.contagens || []).concat(tarefa.produtividades || []).concat(tarefa.aspectos || [])
          .concat(tarefa.ocorrencias || [])
          .concat(tarefa.semeadura_afericoes || []),
        propriedade: tarefa.propriedade,
        responsavel: tarefa.responsavel || tarefa.nome_responsavel,
        encarregados: tarefa.encarregados,
        safra: tarefa.safra,
        selects: {
          glebas: tarefa.glebas
        },
        status: tarefa.status,
        tipo: this.getTarefaTipo(tarefa.tipo),
        updatedAt: tarefa.updated_at,
        usuario: tarefa.usuario,
        insumo: tarefa.insumo,
        area: tarefa.area,
        padrao_embrapa: tarefa.padrao_embrapa
      };
    }
  };
});
